import type { SelectPassengerEvent } from "@checkout/states/Products/Flight/states/PassengerInformationV2/events";
import {
  type FlightContextV2,
  FlightPassengerSelectorsV2,
  ParentState,
} from "@hopper-b2b/checkout";

export const passengerInformationGuards = {
  shouldShowInfantSeatNotSupportedWarning: (
    ctx: FlightContextV2,
    event: SelectPassengerEvent
  ) => {
    const {
      selectedPassengerIds,
      selectedLapInfantIds,
      userPassengers,
      currentInfantId,
    } = ctx[ParentState.passengerInformation];

    const isAlreadySelected =
      selectedPassengerIds.includes(event.passengerId) ||
      selectedLapInfantIds.includes(event.passengerId);

    if (isAlreadySelected || currentInfantId) {
      return false;
    }

    const fareExcludesINS = FlightPassengerSelectorsV2.getFareExcludesINS({
      context: ctx,
    });

    if (!fareExcludesINS) {
      return false;
    }

    const selectedPassenger = userPassengers.find(
      (p) => p.id === event.passengerId
    );
    if (!selectedPassenger) {
      return false;
    }

    return FlightPassengerSelectorsV2.getIsLapInfant(
      selectedPassenger,
      ctx.flightSearch.departureDate
    );
  },
};
